import Vue from 'vue'
import baseApplicationItem from './baseApplicationItem'
import {merge} from 'lodash'

var module = {
  endpoint: 'sale',
  getNew: {
    id: null,
    deleted: false,
    customer: {},
    products: [],
    removeProducts: [],
    totalAmount: 0,
    currency: {
      name: 'EURO',
      symbol: '€'
    }
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'createdAt',
        title: 'Data',
        sortField: 'createdAt',
        callback: baseApplicationItem.toDate
      },
      {
        name: 'customer.firstName',
        title: 'Nome cliente',
        sortField: 'customer.firstName'
      },
      {
        name: 'customer.lastName',
        title: 'Cognome cliente',
        sortField: 'customer.lastName'
      },
      {
        name: 'totalAmount',
        title: 'Totale',
        sortField: 'totalAmount',
        callback: baseApplicationItem.currency
      },
      {
        name: '__component:actions-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__component:actions-refund',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
    },
  },
  async getProductSizes (sku) {
    let url = `${this.endpoint}/product/sizes/${sku}`
    let sizes = (await Vue.http.get(url)).body
    console.log('@@@@sizes', sizes)
    return sizes
  },
  async getProductColors (sku, size) {
    let url = `${this.endpoint}/product/colors/${sku}/${size}`
    let colors = (await Vue.http.get(url)).body
    console.log('@@@@colors', colors)
    return colors
  },
  async getProductDTO (sku, qty, size, color) {
    let url = `${this.endpoint}/product/${sku}`
    console.log('@@@@url', url)
    if (qty) {
      url += `?qty=${qty}`
    }
    if (size) {
      if (qty) {
        url += `&size=${size}`
      } else {
        url += `?size=${size}`
      }
    }
    if (color) {
      if (size || qty) {
        url += `&color=${color}`
      } else {
        url += `?color=${color}`
      }
    }
    let productDTO = (await Vue.http.get(url)).body
    console.log('@@@@productDTO', productDTO)
    return productDTO
  },
  async getSaleProductDTO (sku, qty, size, color, sale) {
    let url = `${this.endpoint}/saleproduct/${sku}`
    console.log('@@@@url', url)
    let separator = '?'
    if (qty) {
      url += `${separator}qty=${qty}`
      separator = '&'
    }
    if (size) {
      url += `${separator}size=${size}`
      separator = '&'
    }
    if (color) {
      url += `${separator}color=${color}`
      separator = '&'
    }
    if (sale) {
      url += `${separator}sale=${sale}`
      separator = '&'
    }
    let productDTO = (await Vue.http.get(url)).body
    console.log('@@@@productDTO', productDTO)
    return productDTO
  },
  async refund (model) {
    if (model) {
      let id = model.id
      let url = `${this.endpoint}/refund/${id}`
      let response = (await Vue.http.post(url, model)).body
      return response
    } else {
      return null
    }
  }
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/sales.js